<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import BrokerageShareList from '@components/brokerage-console/share-list'

export default {
  page: {
    title: 'BrokerageConsole::ShareList',
    meta: [{ name: 'description', content: 'BrokerageConsole::ShareList' }],
  },
  components: { BrokerageConsoleLayout, BrokerageShareList },
}
</script>

<template>
  <BrokerageConsoleLayout>
    <BrokerageShareList></BrokerageShareList>
  </BrokerageConsoleLayout>
</template>
